<dx-popup
    #proposalAcceptedEditorPopup
    minWidth="150px"
    minHeight="150px"
    width="40%"
    height="45%"
    title="Work Order Vendor Proposal Documents"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #quotesGrid
                        width="100%"
                        height="100%"
                        allowColumnResizing="true"
                        keyExpr="fileId"
                        [dataSource]="quotesList"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [selectedRowKeys]="selectedRowKeys"
                        (onContentReady)="onContentReady()"
                        (onSelectionChanged)="onGridSelectionChanged($event)"
                    >
                        <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
                        <dxi-column dataField="fileName" dataType="string" caption="File Name"></dxi-column>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onPopupClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
